export const  htmlTagsRegex = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
export function clearHtmlTags (data: string){
  if(!data) return '';
  return data.replace(htmlTagsRegex,'');
}